/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const file_jpg_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M13 23H2.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h10.036a1 1 0 0 1 .764.354l4.963 5.866a1 1 0 0 1 .237.646V9"
    />
    <path
      fill="#000"
      d="M8.245 19c1.475 0 2.303-.875 2.303-2.304v-4.599H9.121v4.618c0 .768-.314 1.118-.866 1.118-.523 0-.913-.301-.913-1.02H6C6 18.25 6.77 19 8.245 19Zm6.451-6.903h-2.655v6.806h1.428v-2.625h1.227c1.437 0 2.274-.768 2.274-2.09 0-1.323-.837-2.09-2.274-2.09Zm-.228 3.014h-1v-1.847h1c.723 0 1.056.292 1.056.924 0 .631-.333.923-1.056.923Zm9.516.107h-3.32v1.167h1.893c-.02.933-.61 1.351-1.532 1.351-1.047 0-1.836-.962-1.836-2.236 0-1.274.79-2.236 1.836-2.236 1.075 0 1.475.748 1.56 1.06l1.18-.555C23.432 12.681 22.481 12 21.044 12c-1.941 0-3.311 1.449-3.311 3.5s1.37 3.5 3.31 3.5c1.894 0 3.112-1.254 2.941-3.782Z"
    />
  </svg>
)
export default file_jpg_medium
